module.exports = "/assets/b621f542a35fe893f22de02c4128b97a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CL.png
// module id = 1269
// module chunks = 0